module.exports = __webpack_public_path__ + "ef10b1ee61e36ebf0d2ed2123b8d2e31.pdf";